<!-- 资料变更历史 -->
<template>
   <div class='page_content'>
      <processAuditAction ref="processAuditAction"></processAuditAction>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="formList.flowInstanceHis.length > 0" :searchList="formList.flowInstanceHis" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
         </div>
      </div>
      <div class="page_content_center">
         <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
            <el-table-column align="center" label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="wfiId" label="编号" show-overflow-tooltip min-width="130">
               <template slot-scope="scope">
                  <a @click="lookDetail(scope.row)">{{ scope.row.wfiId}}</a>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="wfdName" label="审批流程" show-overflow-tooltip min-width="120">
            </el-table-column>
            <el-table-column align="center" prop="wfiRemark" label="摘要" show-overflow-tooltip min-width="120">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip label="状态" prop="state" min-width="100">
               <template slot-scope="scope">
                  <el-tag size="mini">
                     {{$common.getIsGsp('[{"key":0,"value":"初始"},{"key":-1,"value":"审核退回"},{"key":1,"value":"提交审核"},{"key":2,"value":"审核通过"}]',scope.row.state) }}
                  </el-tag>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="createrName" label="创建人" show-overflow-tooltip min-width="120">
            </el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" show-overflow-tooltip min-width="150">
               <template slot-scope="scope">
                  <span v-if="scope.row.createTime">
                     {{ $common.getLocalTime(scope.row['createTime']) }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <flowInstanceApplyAction v-if="showStatus" ref="flowInstanceApplyAction" @drawerCancel="drawerCancel" :actionData="actionData">
         </flowInstanceApplyAction>
      </el-drawer>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './flowInstance.js'
import SearchScheme from "../../byComponents/SearchScheme.vue";
import flowInstanceApplyAction from "@/components/flowInstanceApplyAction.vue";

export default {
   name: "flowInstanceHis",
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme,flowInstanceApplyAction },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            gchmType: '',
            page: 1,
            rows: 30,
            start: '',
            end: '',
            chanName: '',
            createrName: "",
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: []
         },

         buttonList: [],
         selectedDataIndex: 0,
         showStatus: false,
         actionData: {},
         formList: formList,
         DialogVisible: false,
         seId: "",
         seTitle: "",
         seWidth: "",
         parentSearchData: {},
         sField: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.gchmType': {
         handler: function (newValue, oldValue) {
            this.searchData()
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识ppamId
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      // 子组件触发
      drawerCancel(commitData) {
         this.showStatus = false
         commitData && this.getDataList()
      },
      getPageInfo() {
         this.getDataList()
      },
      lookDetail(data) {
         this.queryDetails(data)
      },
      async queryDetails(dataInfo) {
         const res = await this.$http.flowInstancequeryInfo({ ids: [dataInfo.wfiId] })
         if (res.status = 200) {
            let responseData = await this.$http.flowDeinitqueryDeinitionById({ ids: [dataInfo.wfdId] });
            if (responseData && responseData.status == 200) {
               this.actionData = {
                  cate: 2,
                  wfdId: dataInfo.wfdId,
                  wfiId: res.result.wfiId,
                  wdfForm: responseData.result.wdfForm,
                  wfiContent: res.result.wfiContent,
                  wfdName: res.result.wfdName,
                  wfiRemark: res.result.wfiRemark,
               }
               this.showStatus = true
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 2:
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: '请先选择您要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
               this.queryDetails(dataInfo)
               break;
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },


      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.flowInstancequeryHis(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.pages = responseData.result.pages
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      var objs = this.$common.getSearchData(this.formList.flowInstanceHis, 'page', "rows", 30)
      for (const key in objs) {
         this.$set(this.getRequestData, key, objs[key])
      }
      this.getDataList()
      this.getButtonList()

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>